"use client";

import { useState } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import { FreeMode } from "swiper/modules";
import { useActualData } from "../../../hooks/useActualData";
import { useTranslations } from "next-intl";
import { useStore } from "@/hooks/system/useStore";
import { observer } from "mobx-react-lite";
import S from "./index.module.scss";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";

const ActualFilter = () => {
  const t = useTranslations();
  const { actualYears, actualYearsLoading } = useActualData();
  const { selectedFilters, setSelectedFilters } = useStore("actual");

  const [open, setOpen] = useState(true);

  const filterHandler = (year?: number) => {
    setSelectedFilters({ year, pageNumber: 1 });
  };

  if (!actualYears || actualYearsLoading) return null;

  return (
    <div className={S.wrapper}>
      <button
        onClick={() => setOpen(value => !value)}
        className={clsx(S.filterButton, {
          [S["filterButton--active"]]: open,
        })}
      >
        {selectedFilters.year ? selectedFilters.year : t("allTheTime")} <CustomIcon fileName="arrow-down-icon" />
      </button>
      {open && (
        <div className={S.filterList}>
          <Swiper
            breakpoints={{
              0: {
                spaceBetween: 24,
              },
              1023: {
                spaceBetween: 30,
              },
              1280: {
                spaceBetween: 40,
              },
            }}
            slidesPerView="auto"
            modules={[FreeMode]}
            freeMode={{ enabled: true }}
          >
            <SwiperSlide className={S.filterWrapper} onClick={() => filterHandler(undefined)}>
              <div
                className={clsx(S.filterItem, {
                  [S["filterItem--active"]]: !selectedFilters.year,
                })}
              >
                {t("allTheTime")}
              </div>
            </SwiperSlide>
            {actualYears.map(item => (
              <SwiperSlide className={S.filterWrapper} onClick={() => filterHandler(item)} key={item}>
                <div
                  className={clsx(S.filterItem, {
                    [S["filterItem--active"]]: item === selectedFilters.year,
                  })}
                >
                  {item}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default observer(ActualFilter);
